import { AnyObject } from '@estee/elc-universal-utils';

/**
 * Merges an extension configuration into a base configuration object
 * @param baseConfig The base configuration object to extend, e.g. Drupal configuration
 * @param extensionConfig The extension configuration to merge into the base, e.g. Loyalty extensions
 * @returns The merged configuration object
 */
const mergeConfigurationFiles = (baseConfig: AnyObject, extensionConfig: AnyObject) => {
    Object.keys(extensionConfig).forEach(key => {
        if (extensionConfig[key] instanceof Object && key in baseConfig) {
            // Merge nested objects
            mergeConfigurationFiles(baseConfig[key], extensionConfig[key]);
        } else {
            // Add new properties or override existing ones
            baseConfig[key] = extensionConfig[key];
        }
    });

    return baseConfig;
};

export default mergeConfigurationFiles;